import Vue from "vue";
import VueRouter from "vue-router";
import Layout from '@/components/Layout.vue'; // Use PascalCase for component names
import HomeView from "../views/HomeView.vue"; // Correct import of HomeView
import BlogPost from '@/views/BlogPost.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "layout",
    component: Layout,
    redirect: '/home', // Change to '/home' for clarity
    children: [
      {
        path: 'home', // This can remain without a leading slash since it's a child route
        name: 'home',
        component: HomeView, // Use HomeView instead of Home
        meta: {
          pageNum: 1,
        },
      },
    ],
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
      path: '/blog/:id',
      name: 'BlogPost',
      component: BlogPost, // Register the BlogPost route
      props: true,
    },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (from.name) {
    router.app.previousRoute = from;
  }
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  next();
});

export default router;
